import { Ticket } from './../../shared/ticket';
import { QualityGroupUsers } from './../../shared/qaTicket';

import {merge as observableMerge, fromEvent as observableFromEvent,  BehaviorSubject ,  Observable } from 'rxjs';

import {map, debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { Logger } from './../../shared/logger.service';
import { Dialog } from './../../shared/dialog.model';
import { ConfirmdialogComponent } from './../../dialogs/confirmdialog/confirmdialog.component';
import { AuthenticationService } from './../../shared/authentication.service';
import { SuspendedTicket } from './../../shared/qualityticketqueue.model';
import { QualityTicketService } from './../../shared/qualityticketqueue.service';
import { Component, ElementRef, ViewChild, OnInit, forwardRef, ChangeDetectorRef } from '@angular/core';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatTable, MatDialog } from '@angular/material';
import { MatSnackBar } from  '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../shared/user';






import { resolve } from 'url';

@Component({
  selector: "app-qualityqueueexternal",
  templateUrl: "./qualityqueueexternal.component.html",
  styleUrls: ["./qualityqueueexternal.component.scss"]
})

export class QualityqueueexternalComponent implements OnInit {
  screen = false;
  isUnlockDisabled = false;
  isDataAvailable = true;
  role: string;
  displayedColumns = ['LockedBy', 'QualityTicketCreation', 'links'];
  dataChange: BehaviorSubject<SuspendedTicket[]> = new BehaviorSubject<SuspendedTicket[]>([]);
  get data(): SuspendedTicket[] { return this.dataChange.value; }
  dataSource: ConfigurationDataSource | null;
  title: string;
  content: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filter: ElementRef;

  updateLockRow: SuspendedTicket[] = [];
  private category: string;

  constructor(
    public dialog: MatDialog,
    private qualityQueueService: QualityTicketService,
    private cdRef: ChangeDetectorRef,
    private auth: AuthenticationService,
    public router: Router,
    public route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public logger: Logger,
    public authService: AuthenticationService) {
  }
  populateConfigurationQueue() {
    this.route.params.subscribe(params => {
      this.category = params['category'];
    });
    if (this.category == null) {
      this.qualityQueueService.getQualityTickets(this.auth.currentState).subscribe(rcgitems => {
        this.dataChange.next(rcgitems);
        this.isDataAvailable = true;
        this.cdRef.detectChanges();
        this.initSource();
      })
    }
    else {
      this.qualityQueueService.getQualityTicketsByCategory(this.category, this.auth.currentState).subscribe(rcgitems => {
        this.dataChange.next(rcgitems);
        this.isDataAvailable = true;
        this.cdRef.detectChanges();
        this.initSource();
      })
    }

  }

  ngOnInit() {
    this.populateConfigurationQueue();
    this.role = this.authService.role;
  }

  initSource() {
    this.dataSource = new ConfigurationDataSource(this, this.paginator, this.sort);
    observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.dataSource) { return; }
        this.dataSource.filter = this.filter.nativeElement.value;
      });
    this.cdRef.detectChanges();
  }

  qualityClick(row: SuspendedTicket) {
    if (row.LockedBy == 'none') {
      var qualityTicket = new SuspendedTicket(row.TicketID, this.auth.username, row.QueueCategory, row.Creation, row.SuspendedCount, row.GCTicketID, row.GCTicketNumber, row.DeferredBy);
      this.qualityQueueService.lockQualityTicket(row.TicketID, this.auth.username, this.auth.currentState).subscribe(res => {
        this.router.navigate(["ticket/" + row.GCTicketNumber]);
      });
    }
    else if (row.LockedBy == this.auth.username) {
      this.router.navigate(["ticket/" + row.GCTicketNumber]);
    }
    else {
    }
  }

  unlockTicket(row: SuspendedTicket) {
    if (row.LockedBy != 'none') {
      var qualityTicket = new SuspendedTicket(row.TicketID, 'none', row.QueueCategory, row.Creation, row.SuspendedCount, row.GCTicketID, row.GCTicketNumber, row.DeferredBy);
      this.qualityQueueService.lockQualityTicket(row.TicketID, 'none', this.auth.currentState).subscribe(res => {
        this.showSnackbarMessage('Ticket unlocked.');
        this.qualityQueueService.getQualityTicketsByCategory("external", this.auth.currentState).subscribe(rcgitems => {
          this.dataChange.next(rcgitems);
          this.isDataAvailable = true;
          this.cdRef.detectChanges();
          this.initSource();
        })
      });
    }
  }

  generateQueue() {
    let dialogRef = this.dialog.open(ConfirmdialogComponent, {
      width: '600px',
      disableClose: true,
      data: {
        title: 'Generate Queue',
        content: 'Are you sure?'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != 'Cancel') {
        this.screen = true;
        this.logger.userLog(this.authService.username, " Generate queue internal.");
        this.qualityQueueService.generateQualityTicketQueueExternal(this.authService.username, this.authService.currentState).subscribe(
          res => {

            this.dataChange.next(res);
            this.isDataAvailable = true;
            this.cdRef.detectChanges();
            this.initSource();
            this.showSnackbarMessage('Tickets generated.');
            this.screen = false;
          });
      }

    })


  }

  clearQueue() {
    let dialogRef = this.dialog.open(ConfirmdialogComponent, {
      width: '600px',
      disableClose: true,
      data: {
        title: 'Clear Queue',
        content: 'Are you sure?'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != 'Cancel') {
        this.logger.userLog(this.authService.username,  " clear the queue external.");
        this.qualityQueueService.clearQualityQueueExternal(this.authService.username, this.auth.currentState).subscribe(res => {
          this.dataChange.next(res);
          this.isDataAvailable = true;
          this.cdRef.detectChanges();
          this.initSource();
          this.showSnackbarMessage('Tickets cleared.');
        })
      }
    })
  }

  showSnackbarMessage(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000
    });
  }
}

export class ConfigurationDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  dataChange: BehaviorSubject<SuspendedTicket[]> = new BehaviorSubject<SuspendedTicket[]>([]);
  get data(): SuspendedTicket[] { return this.dataChange.value; }

  filteredData: SuspendedTicket[] = [];
  renderedData: SuspendedTicket[] = [];

  constructor(private rcgcomponent: QualityqueueexternalComponent,
    private _paginator: MatPaginator,
    private _sort: MatSort) {
    super();
    this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<SuspendedTicket[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.rcgcomponent.dataChange,
      this._sort.sortChange,
      this._filterChange,
      this._paginator.page,
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      // Filter data
      this.filteredData = this.rcgcomponent.data.slice().filter((item: SuspendedTicket) => {
        const searchStr = (item.LockedBy).toLowerCase();
        return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
      });

      // Sort filtered data
      const sortedData = this.sortData(this.filteredData.slice());

      // Grab the page's slice of the filtered sorted data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
      return this.renderedData;
    }));
  }

  disconnect() { }

  /** Returns a sorted copy of the database data. */
  sortData(data: SuspendedTicket[]): SuspendedTicket[] {
    if (!this._sort.active || this._sort.direction === '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'QualityTicketId': [propertyA, propertyB] = [a.TicketID, b.TicketID]; break;
        case 'TicketId': [propertyA, propertyB] = [a.GCTicketID, b.GCTicketID]; break;
        case 'LockedBy': [propertyA, propertyB] = [a.LockedBy, b.LockedBy]; break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}
